import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';

import PageTitle from 'components/common/PageTitle';

const styles = () => ({
  root: {
    marginBottom: 15,
  },
});

const ProfileToolbar = ({ classes }) => (
  <Toolbar
    className={classes.root}
    disableGutters
  >
    <Grid
      container
      justify="space-between"
      alignItems="center"
      spacing={24}
    >
      <Grid item>
        <PageTitle
          text="Profile"
          variant="button"
          goBack
        />
      </Grid>
    </Grid>
  </Toolbar>
);

ProfileToolbar.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProfileToolbar);



// WEBPACK FOOTER //
// ./src/components/account/ProfileToolbar/ProfileToolbar.js